import React from "react";
 
const NotFoundPage = () => {
    
  
  return (
     <div>
        <h2 className="m-5">Not Found Page    </h2>
     </div>
  
  );
};
export default NotFoundPage;
